import { render, staticRenderFns } from "./SelectDynamicTagsSection.vue?vue&type=template&id=a89d4834&scoped=true"
import script from "./SelectDynamicTagsSection.vue?vue&type=script&lang=js"
export * from "./SelectDynamicTagsSection.vue?vue&type=script&lang=js"
import style0 from "./SelectDynamicTagsSection.vue?vue&type=style&index=0&id=a89d4834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89d4834",
  null
  
)

export default component.exports